import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WelletContext } from '../../context/WelletContext';
import { fetchNetworkStats } from '../../services/associate/associateService';
import { useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';
import Money from '../Common/Money/Money';

const SimpleNetworkStats = () => {
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);
  const currency = useSelector((state) => state.currency.default);
  const [networkSummary, setNetworkSummary] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getNetworkStats = async () => {
    try {
      const result = await fetchNetworkStats(welletContext);
      setNetworkSummary(result);
    } catch (error) {
      setError(error.response.data.errorCode);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getNetworkStats();
  }, []);

  const sekeletonLoading = () => {
    return (
      <div className='d-flex justify-content-between align-items-center text-tertiary font-small fw-600 mt-3'>
        <div className='d-flex'>
          <Skeleton
            width={19}
            height={19}
            variant='circular'
            animation='wave'
            sx={{
              bgcolor: 'grey.900',
              '&::after': {
                background: 'linear-gradient(90deg, transparent, rgba(61,61,61,0.7), transparent)',
              },
            }}
          />
          <div className='ml-2'>
            {' '}
            <Skeleton
              width={200}
              height={'1rem'}
              animation='wave'
              variant='text'
              sx={{
                bgcolor: 'grey.900',
                '&::after': {
                  background:
                    'linear-gradient(90deg, transparent, rgba(61,61,61,0.7), transparent)',
                },
              }}
            />
          </div>
        </div>
        <div>
          <Skeleton
            width={19}
            height={'1rem'}
            variant='text'
            animation='wave'
            sx={{
              bgcolor: 'grey.900',
              '&::after': {
                background: 'linear-gradient(90deg, transparent, rgba(61,61,61,0.7), transparent)',
              },
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <div className='card p-3 text-tertiary'>
      <div className='fw-700 mb-2'>{t('summary')}</div>
      <div className='d-flex flex-column font-small'>
        {loading ? (
          sekeletonLoading()
        ) : (
          <div>
            <div className='d-flex justify-content-between mt-2'>
              <div className='d-flex'>
                <span>{t('networkStats.registeredPromoters')}</span>
              </div>
              <div className='fw-600'>{networkSummary?.registeredAccounts}</div>
            </div>
            {networkSummary?.networkEarnings.map((item) => (
              <div className='d-flex justify-content-between mt-2'>
                <div className='d-flex'>
                  <span>
                    {t(`networkStats.networkEarnings.${item?.goalType}_${item?.prizeType}`)}
                  </span>
                </div>
                <div className='fw-600'>
                  <Money
                    value={item?.amount}
                    symbol={currency?.shortForm}
                    decimal={false}
                    lowDecimals={true}
                  />
                </div>
              </div>
            ))}

            <div className='d-flex justify-content-between mt-2'>
              <div className='d-flex'>
                <span>{t('networkStats.lastNetworkReservation')}</span>
              </div>
              <div className='fw-600'>
                {networkSummary?.daysSinceLastSale <= 0
                  ? '-'
                  : t('daysAgo', { count: networkSummary?.daysSinceLastSale })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SimpleNetworkStats;
